import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('SlotReward')
export class SlotReward {

  @JsonProperty('reward_rank', Number)
  rewardRank: number = 0;

  @JsonProperty('multiplier', Number)
  multiplier: number = 0;

  @JsonProperty('rarity_weight', Number)
  rarityWeight: number = 0;

  @JsonProperty('is_jackpot', Boolean)
  isJackpot: boolean = false;
}
